import { render } from "./App.vue?vue&type=template&id=6eb71280"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6eb71280&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__